/* eslint-disable react/destructuring-assignment */
import * as React from "react";

const MicIosIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={20} fill="none" {...props}>
    <path
      fill={props.color || "#858E99"}
      fillRule="evenodd"
      d="M7.678.023a3.993 3.993 0 0 1 3.993 3.994v5.59a3.993 3.993 0 0 1-7.987 0v-5.59A3.993 3.993 0 0 1 7.678.023Zm6.788 8.986c.331 0 .6.268.6.599 0 3.676-2.996 6.677-6.789 6.965v2.619a.599.599 0 0 1-1.193.08l-.005-.08v-2.619C3.285 16.285.29 13.284.29 9.608a.599.599 0 1 1 1.198 0c0 3.19 2.763 5.79 6.19 5.79 3.426 0 6.19-2.6 6.19-5.79 0-.331.268-.6.598-.6ZM4.882 4.017a2.795 2.795 0 0 1 5.59 0v5.59a2.795 2.795 0 1 1-5.59 0v-5.59Z"
      clipRule="evenodd"
    />
  </svg>
);
export default MicIosIcon;

export const MicIosFilled = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
  >
    <g clipPath="url(#clip0_10474_120837)">
      <path
        d="M7.5625 13.7836V13.7271L7.50633 13.7214C6.28899 13.5975 5.16083 13.0267 4.34 12.1192C3.51918 11.2117 3.064 10.0321 3.0625 8.80852L3 8.80859H3.0625C3.0625 8.69256 3.10859 8.58128 3.19064 8.49923C3.27269 8.41719 3.38397 8.37109 3.5 8.37109C3.61603 8.37109 3.72731 8.41719 3.80936 8.49923C3.89141 8.58128 3.9375 8.69256 3.9375 8.80859C3.9375 9.88604 4.36551 10.9193 5.12738 11.6812C5.88925 12.4431 6.92256 12.8711 8 12.8711C9.07744 12.8711 10.1108 12.4431 10.8726 11.6812C11.6345 10.9193 12.0625 9.88604 12.0625 8.80859C12.0625 8.69256 12.1086 8.58128 12.1906 8.49923C12.2727 8.41719 12.384 8.37109 12.5 8.37109C12.616 8.37109 12.7273 8.41719 12.8094 8.49923C12.8914 8.58126 12.9375 8.69251 12.9375 8.80852C12.936 10.0321 12.4808 11.2117 11.66 12.1192C10.8392 13.0267 9.71101 13.5975 8.49367 13.7214L8.4375 13.7271V13.7836V15.8086C8.4375 15.9246 8.39141 16.0359 8.30936 16.118C8.22731 16.2 8.11603 16.2461 8 16.2461C7.88397 16.2461 7.77269 16.2 7.69064 16.118C7.60859 16.0359 7.5625 15.9246 7.5625 15.8086V13.7836ZM5.0625 8.80859V4.80859C5.0625 4.02952 5.37199 3.28236 5.92287 2.73147C6.47376 2.18058 7.22093 1.87109 8 1.87109C8.77907 1.87109 9.52624 2.18058 10.0771 2.73147C10.628 3.28236 10.9375 4.02952 10.9375 4.80859V8.80859C10.9375 9.58767 10.628 10.3348 10.0771 10.8857C9.52624 11.4366 8.77907 11.7461 8 11.7461C7.22093 11.7461 6.47376 11.4366 5.92287 10.8857C5.37199 10.3348 5.0625 9.58767 5.0625 8.80859Z"
        fill="#3B82F6"
        stroke="#3B82F6"
        strokeWidth="0.125"
      />
    </g>
    <defs>
      <clipPath id="clip0_10474_120837">
        <rect width="16" height="16" fill="white" transform="translate(0 0.808594)" />
      </clipPath>
    </defs>
  </svg>
);
